import { render, staticRenderFns } from "./blok-column.vue?vue&type=template&id=dda15810&scoped=true"
import script from "./blok-column.vue?vue&type=script&lang=js"
export * from "./blok-column.vue?vue&type=script&lang=js"
import style0 from "./blok-column.vue?vue&type=style&index=0&id=dda15810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda15810",
  null
  
)

export default component.exports